<kor-modal
  [visible]="visible"
  width="400px"
  height="auto"
  (visible-changed)="!$event.target.visible ? close.emit() : ''"
>
  <!-- header -->
  <img src="assets/imgs/collections.png" width="60" height="60" />
  <h2>collection details</h2>
  <br /><br />
  <!-- content -->
  <kor-input
    label="name"
    [value]="collection.name"
    (input)="
      collection.name = $event.target.value;
      sharedService.logEvent('edit_collection_name_input')
    "
  ></kor-input>
  <br />
  <!-- footer -->
  <kor-button
    slot="footer"
    label="cancel"
    color="secondary"
    (click)="
      close.emit(); sharedService.logEvent('edit_collection_cancel_clicked')
    "
  ></kor-button>
  <kor-button
    slot="footer"
    label="save"
    (click)="
      close.emit();
      save.emit(collection);
      sharedService.logEvent('edit_collection_save_clicked')
    "
  ></kor-button>
</kor-modal>
